exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#authForm #errors {\n  color: #fa755a;\n  margin-top: 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Payments/PaymentCollection/components/PaymentForm/AuthForm/authForm.scss
// module id = 1334
// module chunks = 1